import React, { useState } from "react";
import { Box, Typography, TextField, Button, Stack } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useMediaQuery, useTheme } from "@mui/material";

const HelpCenterSearch = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeTab, setActiveTab] = useState("Creator topics");

  const tabs = ["Creator topics", "Member topics", "General topics"];

  return (
    <>
      {/* Search Section */}
      <Box
        sx={{
          backgroundColor: "#FC0108",
          color: "white",
          padding: "50px 0",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ width: isMobile ? "90%" : "60%", textAlign: "left" }}>
          {/* Main Heading */}
          <Typography
            variant={isMobile ? "h4" : "h3"}
            sx={{ marginBottom: 4, fontWeight: "bold" }}
          >
            How can we help?
          </Typography>

          {/* Search Bar */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "white",
              borderRadius: "30px",
              padding: "5px 15px",
              marginBottom: 4,
            }}
          >
            <TextField
              variant="standard"
              placeholder="Search"
              fullWidth
              InputProps={{ disableUnderline: true }}
              sx={{ marginRight: 1 }}
            />
            <Button>
              <SearchIcon />
            </Button>
          </Box>

          {/* Browse by topic */}
          <Typography variant="h6" sx={{ marginBottom: 2 }}>
            Browse by topic
          </Typography>

          {/* Topic Tabs */}
          <Stack
            direction={isMobile ? "column" : "row"}
            spacing={2}
            sx={{ marginBottom: 4 }}
          >
            {tabs.map((topic) => (
              <Button
                key={topic}
                variant="contained"
                onClick={() => setActiveTab(topic)}
                sx={{
                  backgroundColor: activeTab === topic ? "white" : "#FC0108",
                  color: activeTab === topic ? "#FC0108" : "white",
                  borderRadius: "20px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor:
                      activeTab === topic ? "#ffcccc" : "#FC0108",
                  },
                  width: isMobile ? "100%" : "auto",
                  fontSize: isMobile ? "16px" : "18px",
                  padding: isMobile ? "12px 20px" : "10px 30px",
                  border: activeTab === topic ? "none" : "2px solid white",
                }}
              >
                {topic}
              </Button>
            ))}
          </Stack>
        </Box>
      </Box>

      {/* Content Section */}
      <Box
        sx={{
          padding: "20px",
          textAlign: "left",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Typography variant="h5" sx={{ marginBottom: 2 }}>
          {activeTab} Content
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "repeat(4, 1fr)",
            gap: 2,
          }}
        >
          {Array.from({ length: 8 }).map((_, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: "white",
                border: "1px solid #ddd",
                borderRadius: "12px",
                padding: "20px",
                textAlign: "center",
                cursor: "pointer",
                transition: "transform 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              <Typography variant="h6">Topic {index + 1}</Typography>
              <Typography variant="body2">
                Description for topic {index + 1}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default HelpCenterSearch;
